<template>
    <div class="landing-page">
        <NavBarPP>
            <!-- NOT LOGGED -->

            <template v-slot:items-link v-if="!getIsLogged">
                <li :class="'nav-item'">
                    <router-link class="nav-link" to="/">
                        Home
                        <span class="sr-only">(current)</span>
                    </router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" to="/quem-somos">Quem somos</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" to="/como-surgimos">Como surgimos</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" to="/para-quem-e">Para quem é</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'BenefitsPage' }">Benefícios</router-link>
                </li>
            </template>

            <template v-slot:right-buttons v-if="!getIsLogged">
                <span class="navbar-text">
                    <li class="nav-item">
                        <router-link type="button" :to="{ name: 'LoginForm' }">
                            <button type="button" :class="`btn btn-sm-nav btn-${getIsDarkTheme ? 'light' : 'dark'}`">
                                Entrar
                            </button>
                        </router-link>
                    </li>
                </span>
            </template>

            <!-- LOGGED -->

            <!-- <template v-slot:first-items v-if="getIsLogged">

            </template> -->

            <template v-slot:items-link-logged v-if="getIsLogged">
                <li :class="'nav-item'">
                    <b-nav-item-dropdown text="Sobre a Plataforma">
                        <b-dropdown-item router-link :to="{ name: 'HomePage' }">
                            Página inicial
                        </b-dropdown-item>
                        <b-dropdown-item router-link to="/quem-somos">Quem somos</b-dropdown-item>
                        <b-dropdown-item router-link to="/como-surgimos">Como surgimos</b-dropdown-item>
                        <b-dropdown-item router-link to="/para-quem-e">Para quem é</b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'BenefitsPage' }">Benefícios</b-dropdown-item>
                    </b-nav-item-dropdown>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" to="/plataforma">Painel de Oportunidades</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'ConnectionsPage' }">Conexões</router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link to="#" class="nav-link" v-b-toggle.sidebar-backdrop @click="openSidebar()">
                        Convites
                    </router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'MessagesPage' }">Mensagens</router-link>
                </li>
            </template>

            <template v-slot:right-buttons-logged v-if="getIsLogged">
                <span class="navbar-text">
                    <li :class="'nav-item'">
                        <button class="btn btn-default">
                            <i class="far fa-bell"></i>
                        </button>
                    </li>

                    <li :class="'nav-item profile-options'">
                        <b-nav-item-dropdown :text="usuario.name">
                            <b-dropdown-item router-link :to="{ name: 'RegisterGridPage' }" v-if="getAllowRegisterBtn">
                                <b-icon icon="pencil"></b-icon>
                                Continuar Cadastro
                            </b-dropdown-item>
                            <b-dropdown-item router-link :to="{ name: 'MyProfilePage' }">
                                <b-icon icon="person"></b-icon>
                                Meu Perfil
                            </b-dropdown-item>
                            <b-dropdown-item router-link :to="{ name: 'NewPasswordForm' }">
                                <b-icon icon="unlock"></b-icon>
                                Alterar Senha
                            </b-dropdown-item>
                            <b-dropdown-item @click="logout()">
                                <b-icon icon="box-arrow-right"></b-icon>
                                Sair
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </li>
                </span>
            </template>
        </NavBarPP>

        <main>
            <router-view
                :registeredPowers="getLandingPage.potenciasCadastradas"
                :registeredInvestors="getLandingPage.investidoresCadastrados"
                :registeredConnections="getLandingPage.conexoesRealizadas"
            ></router-view>

            <div v-if="!['PrivacyPolicy', 'TermsUsePage', 'BenefitsPage'].includes(this.$router.history.current.name)">
                <section>
                    <PartnersSection :partnersData="getLandingPage.ods" />
                </section>

                <section>
                    <IniciativeSection :charts="getLandingPage.charts" />
                </section>

                <section>
                    <MapRegionSection :states="getStates" v-if="this.$router.history.current.name === 'HomePage'" />
                </section>

                <section>
                    <FeedbackSection />
                </section>

                <section style="background: #fff">
                    <DirectorsLogoSection />
                </section>
            </div>
        </main>

        <FooterPP />

        <b-sidebar id="sidebar-backdrop" title="Enviar convite" backdrop shadow right>
            <div>
                <div>
                    Ajude a Plataforma Potências Periféricas (PPP) a conectar mais e mais pessoas e iniciativas.
                    Preencha os campos abaixo e convide seus parceiros e amigos para participarem da plataforma.
                    <br /><br />Quanto maior a sua rede, melhor!
                </div>

                <b-form @submit.stop.prevent="onSidebarSubmit" novalidate>
                    <b-form-group label="Nome" label-for="name">
                        <b-form-input
                            id="name"
                            name="name"
                            v-model="$v.sidebarForm.name.$model"
                            type="text"
                            placeholder="Digite nome"
                            :state="validateStateSidebar('name')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('name')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="E-mail" label-for="email">
                        <b-form-input
                            id="email"
                            name="email"
                            v-model="$v.sidebarForm.email.$model"
                            type="text"
                            placeholder="Digite e-mail"
                            :state="validateStateSidebar('email')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('email')">
                            <div v-if="!$v.sidebarForm.email.required">Campo obrigatório</div>
                            <div v-if="!$v.sidebarForm.email.email">Escreva um e-mail válido</div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="'dark'" class="radius-6 submit" v-b-toggle.sidebar-backdrop>
                        Enviar convite
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import NavBarPP from '@/ui/navbar-pp/NavBarPP'
import FooterPP from '@/ui/footer-pp/FooterPP'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import DirectorsLogoSection from '@/pages/public/components/landing-page/directors-logo-section/DirectorsLogoSection'
import FeedbackSection from '@/pages/public/components/landing-page/feedback-section/FeedbackSection'
import MapRegionSection from '@/pages/public/components/landing-page/map-region-section/MapRegionSection'
import IniciativeSection from '@/pages/public/components/landing-page/iniciative-section/IniciativeSection'
import PartnersSection from '@/pages/public/components/landing-page/partners-section/PartnersSection'
import IdSection from '@//pages/public/components/landing-page/id-section/IdSection'
import { AuthenticationApi } from './../../../api/authentication'
import { LandingPageApi } from './../../../api/landing-page-api'
import { PlatformApi } from './../../../api/platform'

const authenticationApi = new AuthenticationApi()
const landingPageApi = new LandingPageApi()
const platformApi = new PlatformApi()

export default {
    name: 'LandingPage',
    components: {
        FooterPP,
        NavBarPP,
        DirectorsLogoSection,
        FeedbackSection,
        MapRegionSection,
        IniciativeSection,
        PartnersSection,
        IdSection,
        DangerModalPP
    },
    data() {
        return {
            usuario: null,
            message: null,
            states: [],
            landingPage: {
                charts: null,
                conexoesRealizadas: 0,
                investidoresCadastrados: 0,
                potenciasCadastradas: 0,
                ods: {
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0,
                    5: 0,
                    6: 0,
                    7: 0,
                    8: 0,
                    9: 0,
                    10: 0,
                    11: 0,
                    12: 0,
                    13: 0
                }
            },
            sidebarForm: {
                name: null,
                email: null
            }
        }
    },
    validations: {
        sidebarForm: {
            name: { required },
            email: { required, email }
        }
    },
    computed: {
        getIsLogged() {
            return this.$store.state.isLogged
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getLandingPage() {
            return this.landingPage
        },
        getAllowRegisterBtn() {
            return this.$store.state.allowRegisterBtn
        },
        getStates() {
            return this.states
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'changeIsLogged', 'setMapData', 'setAllowRegisterBtn']),
        validateStateSidebar(nameField) {
            const { $dirty, $error } = this.$v.sidebarForm[nameField]
            return $dirty ? !$error : null
        },
        onSidebarSubmit(event) {
            this.$v.sidebarForm.$touch()
            if (this.$v.sidebarForm.$anyError) {
                return null
            }
        },
        openSidebar() {
            this.$v.sidebarForm.$reset()
            this.sidebarForm.name = null
            this.sidebarForm.email = null
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        logout() {
            this.setIsLoading(true)

            authenticationApi
                .logout()
                .then(response => {
                    localStorage.clear()
                    this.$router.push('/')
                    this.changeIsLogged(false)
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        }
    },
    created() {
        this.setIsLoading(true)
        let currentUsuario = JSON.parse(localStorage.getItem('usuario'))

        if (currentUsuario) {
            this.usuario = currentUsuario
            this.changeIsLogged(true)
        } else {
            this.changeIsLogged(false)
        }

        landingPageApi
            .getHomeData()
            .then(response => {
                let data = null

                if (response.data.data) {
                    data = response.data.data
                    this.landingPage.ods = data.ods
                    this.landingPage.conexoesRealizadas = data.conexoesRealizadas
                    this.landingPage.investidoresCadastrados = data.investidoresCadastrados
                    this.landingPage.potenciasCadastradas = data.potenciasCadastradas
                    this.landingPage.charts = data.grafico
                }

                if (response.data.dataMapa) {
                    this.setMapData(response.data.dataMapa)
                }

                if (response.data.dataState) {
                    this.states = response.data.dataState
                }

                if (this.getIsLogged) {
                    platformApi
                        .getAllProfileData(currentUsuario.id)
                        .then(response => {
                            const data = response.data.data

                            if (data) {
                                this.setAllowRegisterBtn(data.Anexos === null)
                            }
                        })
                        .catch(error => {
                            this.message = error.response.data.message
                            this.$refs.warningModal.showModal()
                        })
                        .finally(() => {
                            this.setIsLoading(false)
                        })
                }
            })
            .catch(error => {
                this.message = error.response.data.message
                this.$refs.warningModal.showModal()
            })
            .finally(() => {
                this.setIsLoading(false)
            })
    }
}
</script>

<style scope src="./LandingPage-light-theme.css"></style>
<style scope src="./LandingPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/landing-page/LandingPage.vue